import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.$t(`dashboards.${_vm.cleanedLabel}`)))]),_c(VRow,{attrs:{"dense":""}},_vm._l((_vm.sorted),function(item,idx){return _c(VCol,{key:`${_vm.sectionLabel}-${idx}`,attrs:{"cols":"3"}},[_c('summary-item',{attrs:{"item":item,"category":_vm.category}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }